/**
 * FilterPills — single-select pill row used in every left panel for
 * status/type/plan filtering. Gold highlight on active.
 */

import React from 'react';
import { colors, fonts } from './colors';

export interface FilterOption {
  key: string;
  label: string;
  count?: number;
}

interface FilterPillsProps {
  options: FilterOption[];
  activeKey: string;
  onChange: (key: string) => void;
}

const FilterPills: React.FC<FilterPillsProps> = ({ options, activeKey, onChange }) => {
  return (
    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
      {options.map((opt) => {
        const isActive = opt.key === activeKey;
        return (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            style={{
              background: isActive ? colors.gold : colors.navy3,
              color: isActive ? colors.navy : colors.muted,
              border: 'none',
              borderRadius: '12px',
              padding: '4px 10px',
              fontSize: '11px',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              cursor: 'pointer',
              fontFamily: fonts.body,
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              transition: 'background 0.1s',
            }}
          >
            <span>{opt.label}</span>
            {opt.count != null && (
              <span style={{ opacity: 0.7, fontSize: '10px' }}>{opt.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default FilterPills;
